module.exports = __webpack_public_path__ + "static/RTS-90b9afcfc5e76272df24fe0791bb21e6.png";